// ** React Imports
import { Fragment, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
// ** Third Party Components
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import { NavItem, NavLink, Button } from "reactstrap"
// ** Third Party Components
import { Menu } from "react-feather"
import {
  handleMenuCollapsed
} from "../../../../../redux/layout"
import { useDispatch, useSelector } from "react-redux"
// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader"
import VerticalNavMenuItems from "./VerticalNavMenuItems"
// import GlobalVariable from "../../../../../settings/global"
// const headerText = GlobalVariable.headerText
import themeConfig from "../../../../../configs/themeConfig"

const trueBool = true
const Sidebar = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  // ** Props
  const { menuCollapsed, menu, skin, menuData } = props

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [currentActiveGroup, setCurrentActiveGroup] = useState([])
  const [activeItem, setActiveItem] = useState(null)
  const stores = useSelector((state) => state.commonreducerSlice)

  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)

  // ** Ref
  const shadowRef = useRef(null)

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true)
  }

  // ** Scroll Menu
  const scrollMenu = (container) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.add("d-block")
      }
    } else {
      if (shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.remove("d-block")
      }
    }
  }

  const navigateMainPage = () => {
    sessionStorage.setItem('pageTransition', 'LR')
    if (stores?.unauthorize) {
      navigate('/Unauthorized')
    } else {
      navigate('/dashboard')
    }
    
  }
  return (
    <Fragment>
      <div
        className={classnames(
          "main-menu menu-fixed menu-accordion menu-shadow",
          {
            expanded: menuHover || menuCollapsed === false,
            "menu-light": skin !== "semi-dark" && skin !== "dark",
            "menu-dark": skin === "semi-dark" || skin === "dark"
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}
        style={{ width: menuCollapsed ? '69px' : '225px', background: 'none', boxShadow: '10px 0 5px -5px #e9dede' }}
      // top: headerText ? '78px' : '64px',

      >
        {menu ? (
          menu({ ...props })
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}
            <VerticalMenuHeader
              setGroupOpen={setGroupOpen}
              menuHover={menuHover}
              {...props}
            />
            {/* Vertical Menu Header Shadow */}
            <div className="shadow-bottom" ref={shadowRef}></div>
            {/* Perfect Scrollbar */}
            <PerfectScrollbar
              className="main-menu-content"
              options={{ wheelPropagation: false }}
              onScrollY={(container) => scrollMenu(container)}
              style={{ background: '#fff' }}
            >
              <ul className="nav navbar-nav text-center">
                <li className="nav-item">
                  <NavLink
                    onClick={() => navigateMainPage()}
                    className=""
                  >
                    <span className="brand-logo">
                      <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                    </span>
                  </NavLink>
                </li>
              </ul>
              <ul className="navigation navigation-main">
                <NavItem className="mobile-menu me-auto d-none" style={{ marginBottom: '0.8rem' }}>
                  <NavLink
                    className={menuCollapsed ? "nav-menu-main menu-toggle hidden-xs is-active p-0 text-center" : "nav-menu-main menu-toggle hidden-xs is-active p-0 text-left"}
                    onClick={() => {
                      dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
                    }}
                  >
                    <Button
                      className={menuCollapsed ? "btn-icon btn_Action menuiconwarpper" : "btn-icon btn_Action menuiconwarpper1"}
                      color="secondary"
                    >
                      <Menu className="ficon" size={33} style={{ width: '32px', height: '32px', margin: 0 }} />
                    </Button>
                  </NavLink>
                </NavItem>
                <Fragment>             
  <VerticalNavMenuItems
  items={menuData}
  menuData={menuData}
  menuHover={menuHover}
  groupOpen={groupOpen}
  activeItem={activeItem}
  groupActive={groupActive}
  setGroupOpen={setGroupOpen}
  menuCollapsed={menuCollapsed}
  setActiveItem={setActiveItem}
  setGroupActive={setGroupActive}
  currentActiveGroup={currentActiveGroup}
  setCurrentActiveGroup={setCurrentActiveGroup}
/>  
    </Fragment>           
              </ul>          
            </PerfectScrollbar>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

export default Sidebar
